import { BlitzPage } from "@blitzjs/next"
import { Container, Box, Typography, Tab, Tabs } from "@mui/material"

import Suspense from "app/core/components/Suspense"
import Layout from "app/core/layouts/Layout"
import { DeploymentList } from "app/deployments/components/DeploymentList"
import router from "next/router"
import { useState } from "react"

const DEPLOYMENTS_TAB_KEY = "deployments"
const DEV_DELIVIRIES_TAB_KEY = "dev-deliveries"

const DeploymentsPage: BlitzPage = () => {
  const [tab, setTab] = useState(DEPLOYMENTS_TAB_KEY)

  const handleTabChange = (_event: React.SyntheticEvent, newValue: string) => {
    setTab(newValue)
  }

  const goToDevDeliviries = async () => {
    await router.push("/deployments/dev-deliviries")
  }

  return (
    <Container maxWidth={false}>
      <Box
        sx={{
          m: 1,
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography sx={{ my: 4 }} variant="h4" component="h2">
          Deployments
        </Typography>
      </Box>
      <Tabs value={tab} onChange={handleTabChange} sx={{ flexGrow: 1 }}>
        <Tab value={DEPLOYMENTS_TAB_KEY} label="Deployments" />
        <Tab
          value={DEV_DELIVIRIES_TAB_KEY}
          label="Developments Deliviries"
          onClick={goToDevDeliviries}
        />
      </Tabs>

      <Suspense>
        <Box sx={{ display: tab === DEPLOYMENTS_TAB_KEY ? "block" : "none" }}>
          <DeploymentList />
        </Box>
      </Suspense>
    </Container>
  )
}

DeploymentsPage.authenticate = true
DeploymentsPage.getLayout = (page) => <Layout title="Deployments">{page}</Layout>

export default DeploymentsPage
